import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../lang/en";
import ru from "../lang/ru";

const i18nextConfig = i18next.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    ru: {
      translation: ru,
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18nextConfig;
